import type { Transition, Variants } from "motion/react";

// Courbe douce et chaleureuse (easeOutQuint-ish), partagée par toutes les apparitions.
export const easeSoft: [number, number, number, number] = [0.22, 1, 0.36, 1];

// Spring vivant mais court pour les hover/tap des boutons et cartes.
export const springSnappy: Transition = {
  type: "spring",
  stiffness: 400,
  damping: 24,
  mass: 0.6,
};

// Spring plus moelleux pour les cartes (lift au survol).
export const springSoft: Transition = {
  type: "spring",
  stiffness: 260,
  damping: 22,
};

// Réglage viewport commun : marge basse très large → tout le contenu de la page
// apparaît dès le chargement (simple fondu), aucun bloc ne reste vide en attendant le scroll.
export const viewportOnce = { once: true, margin: "0px 0px 100000px 0px" } as const;

// Apparition standard : fondu + léger translate-up.
export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: easeSoft },
  },
};

// Variante plus discrète (petits éléments, badges, lignes).
export const fadeIn: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: easeSoft },
  },
};

// Conteneur qui orchestre l'apparition en cascade de ses enfants.
export const staggerContainer = (
  stagger = 0.08,
  delayChildren = 0,
): Variants => ({
  hidden: {},
  show: {
    transition: { staggerChildren: stagger, delayChildren },
  },
});
